import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  MAX_LIMIT_LABEL: `${cleanedFilename(__filename)}-max-limit-label`,
  DROPDOWN_LIST: `${cleanedFilename(__filename)}-dropdown-list`,
};
